import React, { useState } from "react";
import { injectIntl } from "react-intl";
import DetailsItem from "../Details/DetailsItem";
import {
  withRules,
  rulesShape,
  withApi,
  apiShape,
  withNotifier,
  notifierShape,
} from "../../context";
import { intlShape } from "../../shapes";

type Props = {
  asset: {
    id: number;
    product: {
      id: number;
    };
    status?: {
      code?: string;
      name?: string;
    };
  };
  rules: rulesShape;
  api: apiShape;
  notifier: notifierShape;
  intl: intlShape;
};

export function AssetStatus({ asset, api, notifier, rules, intl }: Props) {
  const [healthCondition, setHealthCondition] = useState();

  React.useEffect(() => {
    if (rules.asset(asset).get("showAssetStatusWithHealthCondition")) {
      const loadHealthCondition = async () => {
        try {
          const response = await api.get(
            `/assets/${asset.id}/health_conditions`,
          );
          if (
            response.health_conditions.length > 0 &&
            response.health_conditions[0].diagnosis_code !== "OK" &&
            response.health_conditions[0].diagnosis_code.indexOf("XGEN") !== 0
          ) {
            setHealthCondition(response.health_conditions[0]);
          }
        } catch (error) {
          notifier.showError(api.translateError(error));
        }
      };
      loadHealthCondition();
    }
  }, [asset.id]);

  return (
    <DetailsItem
      id="asset-status"
      isNamurIcon
      icon={asset.status?.code}
      translationKey="label.asset_status"
      // @ts-expect-error TS(2322) FIXME: Type '{ children: Element; id: string; isNamurIcon... Remove this comment to see the full error message
      intl={intl}
    >
      <span id="extended-asset-status">
        {asset.status?.name}
        {healthCondition ? (
          <span>
            (
            <a
              href={`/app/health/products/${asset.product?.id}/health_conditions/${(healthCondition as $TSFixMe).id}`}
              target="_new"
              id="health_link"
            >
              {(healthCondition as $TSFixMe).diagnosis_code}
            </a>
            )
          </span>
        ) : null}
      </span>
    </DetailsItem>
  );
}

export default injectIntl(withApi(withNotifier(withRules(AssetStatus))));
